"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _mediaPipeUtils = _interopRequireDefault(require("../../util/mediaPipeUtils"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mediaPipeUtils = _mediaPipeUtils["default"].getInstance();
Entry.AI_UTILIZE_BLOCK.faceLandmarker = {
  name: 'faceLandmarker',
  imageName: 'faceLandmarker.svg',
  category: 'video',
  title: {
    ko: '얼굴 인식',
    en: 'Face Detection'
  },
  titleKey: 'Workspace.face_landmarker_title_text',
  description: Lang.Msgs.ai_utilize_face_landmarker_description,
  descriptionKey: 'Msgs.ai_utilize_face_landmarker_description',
  isInitialized: false,
  init: function init() {
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return mediaPipeUtils.initialize();
          case 1:
            Entry.AI_UTILIZE_BLOCK.faceLandmarker.isInitialized = true;
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  destroy: function destroy() {
    mediaPipeUtils.destroy();
    Entry.AI_UTILIZE_BLOCK.faceLandmarker.isInitialized = false;
  }
};
Entry.AI_UTILIZE_BLOCK.faceLandmarker.getBlocks = function () {
  var params = {
    getEventIndicator: function getEventIndicator() {
      return {
        type: 'Indicator',
        img: 'block_icon/start_icon_face.svg',
        size: 14,
        position: {
          x: 0,
          y: -2
        }
      };
    },
    getCommonIndicator: function getCommonIndicator() {
      return {
        type: 'Indicator',
        img: 'block_icon/ai_face_icon.svg',
        size: 11
      };
    },
    getFaceNumber: function getFaceNumber() {
      return {
        type: 'Dropdown',
        options: [['1', 0], ['2', 1], ['3', 2], ['4', 3]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getGender: function getGender() {
      return {
        type: 'Dropdown',
        options: [[Lang.video_gender.female, 'female'], [Lang.video_gender.male, 'male']],
        value: 'female',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getFaceCategory: function getFaceCategory() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_gender, 'gender'], [Lang.Blocks.video_age, 'age'], [Lang.Blocks.video_emotion, 'emotion']],
        value: 'gender',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getOperators: function getOperators() {
      return {
        type: 'Dropdown',
        options: [['=', 'EQUAL'], ['!=', 'NOT_EQUAL'], ['>', 'GREATER'], ['<', 'LESS'], ['≥', 'GREATER_OR_EQUAL'], ['≤', 'LESS_OR_EQUAL']],
        value: 'EQUAL',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getEmotions: function getEmotions() {
      return {
        type: 'Dropdown',
        options: [[Lang.video_emotion_params.angry, 'angry'], [Lang.video_emotion_params.disgust, 'disgust'], [Lang.video_emotion_params.fear, 'fear'], [Lang.video_emotion_params.happy, 'happy'], [Lang.video_emotion_params.neutral, 'neutral'], [Lang.video_emotion_params.sad, 'sad'], [Lang.video_emotion_params.surprise, 'surprise']],
        value: 'angry',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getFacePoint: function getFacePoint() {
      return {
        type: 'Dropdown',
        options: [[Lang.video_body_coord_params.left_eye, 374], [Lang.video_body_coord_params.right_eye, 145], [Lang.video_body_coord_params.nose, 4], [Lang.video_body_coord_params.left_mouth, 291], [Lang.video_body_coord_params.right_mouth, 61], [Lang.video_body_coord_params.upper_lip, 0], [Lang.video_body_coord_params.lower_lip, 17]],
        value: 374,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE,
        dropdownSync: 'handPoint'
      };
    },
    getAxis: function getAxis() {
      return {
        type: 'Dropdown',
        options: [['x', 'x'], ['y', 'y']],
        value: 'x',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getStartStop: function getStartStop() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_start, 'start'], [Lang.Blocks.video_end, 'stop']],
        value: 'start',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getShowHide: function getShowHide() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_show_video, 'show'], [Lang.Blocks.video_hide_video, 'hide']],
        value: 'show',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    }
  };
  return {
    face_landmarker_title: {
      skeleton: 'basic_text',
      color: EntryStatic.colorSet.common.TRANSPARENT,
      params: [{
        type: 'Text',
        text: Lang.Blocks.face_landmarker_title_text,
        color: EntryStatic.colorSet.common.TEXT,
        align: 'center'
      }],
      def: {
        type: 'face_landmarker_title'
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      events: {}
    },
    when_face_landmarker: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_event',
      statements: [],
      params: [params.getEventIndicator()],
      events: {},
      def: {
        params: [null],
        type: 'when_face_landmarker'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      event: 'when_face_landmarker',
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        return script.callReturn();
      },
      wikiClass: 'ai_utilize_face'
    },
    face_landmarker: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getStartStop(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'face_landmarker'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var value;
          return _regenerator["default"].wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                value = script.getField('VALUE');
                if (mediaPipeUtils.isInitialized) {
                  _context2.next = 1;
                  break;
                }
                _context2.next = 1;
                return mediaPipeUtils.initialize();
              case 1:
                if (!(value === 'start')) {
                  _context2.next = 3;
                  break;
                }
                _context2.next = 2;
                return mediaPipeUtils.startFaceLandmarker(value);
              case 2:
                _context2.next = 4;
                break;
              case 3:
                _context2.next = 4;
                return mediaPipeUtils.stopFaceLandmarker(value);
              case 4:
                return _context2.abrupt("return", script.callReturn());
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      wikiClass: 'ai_utilize_face'
    },
    draw_detected_face: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getShowHide(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'draw_detected_face'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          var value;
          return _regenerator["default"].wrap(function (_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                value = script.getField('VALUE');
                if (mediaPipeUtils.isInitialized) {
                  _context3.next = 1;
                  break;
                }
                _context3.next = 1;
                return mediaPipeUtils.initialize();
              case 1:
                if (value === 'show') {
                  mediaPipeUtils.changeDrawDetectedFaceLandmarker(true);
                } else {
                  mediaPipeUtils.changeDrawDetectedFaceLandmarker(false);
                }
                return _context3.abrupt("return", script.callReturn());
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }))();
      },
      wikiClass: 'ai_utilize_face'
    },
    check_detected_face: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [],
      events: {},
      def: {
        type: 'check_detected_face'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        return mediaPipeUtils.isPrevFaceLandmarker;
      },
      wikiClass: 'ai_utilize_face'
    },
    count_detected_face: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [],
      events: {},
      def: {
        type: 'count_detected_face'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        return mediaPipeUtils.countDetectedFace || 0;
      },
      wikiClass: 'ai_utilize_face'
    },
    locate_to_face: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getFaceNumber(), params.getFacePoint(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'locate_to_face'
      },
      paramsKeyMap: {
        FACE: 0,
        FACE_POINT: 1
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        var face = script.getField('FACE');
        var point = script.getField('FACE_POINT');
        var axis = mediaPipeUtils.getFacePointAxis(face, point);
        if (axis) {
          sprite.setX(axis.x);
          sprite.setY(axis.y);
          if (sprite.brush && !sprite.brush.stop) {
            sprite.brush.lineTo(axis.x, axis.y * -1);
          }
        }
        return script.callReturn();
      },
      wikiClass: 'ai_utilize_face'
    },
    locate_time_to_face: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [{
        type: 'Block',
        accept: 'string',
        defaultType: 'number'
      }, params.getFaceNumber(), params.getFacePoint(), params.getCommonIndicator()],
      events: {},
      def: {
        params: [{
          type: 'number',
          params: ['2']
        }, null, null],
        type: 'locate_time_to_face'
      },
      paramsKeyMap: {
        TIME: 0,
        FACE: 1,
        FACE_POINT: 2
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        if (!script.isStart) {
          var time = script.getNumberValue('TIME', script);
          var frameCount = Math.floor(time * Entry.FPS);
          var face = script.getField('FACE', script);
          var point = script.getField('FACE_POINT', script);
          if (frameCount != 0) {
            var axis = mediaPipeUtils.getFacePointAxis(face, point);
            if (axis) {
              script.isStart = true;
              script.frameCount = frameCount;
              script.dX = (axis.x - sprite.getX()) / script.frameCount;
              script.dY = (axis.y - sprite.getY()) / script.frameCount;
            }
          } else {
            var _axis = mediaPipeUtils.getFacePointAxis(face, point);
            if (_axis) {
              sprite.setX(_axis.x);
              sprite.setY(_axis.y);
              if (sprite.brush && !sprite.brush.stop) {
                sprite.brush.lineTo(_axis.x, _axis.y * -1);
              }
            }
            return script.callReturn();
          }
        }
        if (script.frameCount != 0) {
          sprite.setX(sprite.getX() + script.dX);
          sprite.setY(sprite.getY() + script.dY);
          script.frameCount--;
          if (sprite.brush && !sprite.brush.stop) {
            sprite.brush.lineTo(sprite.getX(), sprite.getY() * -1);
          }
          return script;
        } else {
          delete script.isStart;
          delete script.frameCount;
          return script.callReturn();
        }
      },
      wikiClass: 'ai_utilize_face'
    },
    check_detected_gender: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getFaceNumber()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getGender()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null],
        type: 'check_detected_gender'
      },
      paramsKeyMap: {
        FACE: 0,
        GENDER: 1
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        var face = script.getField('FACE', script);
        var gender = script.getField('GENDER', script);
        var result = mediaPipeUtils.getFaceGender(face);
        return result === gender;
      },
      wikiClass: 'ai_utilize_face'
    },
    check_compare_age: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getFaceNumber()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getOperators()), {}, {
        fontSize: 10
      }), {
        type: 'Block',
        accept: 'string',
        defaultType: 'number'
      }],
      events: {},
      def: {
        params: [null, null, {
          type: 'number',
          params: ['10']
        }],
        type: 'check_compare_age'
      },
      paramsKeyMap: {
        FACE: 0,
        OPERATOR: 1,
        AGE: 2
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        var face = script.getField('FACE', script);
        var operator = script.getField('OPERATOR', script);
        var age = script.getNumberValue('AGE', script);
        var result = mediaPipeUtils.getFaceAge(face);
        switch (operator) {
          case 'EQUAL':
            return result === age;
          case 'NOT_EQUAL':
            return result != age;
          case 'GREATER':
            return result > age;
          case 'LESS':
            return result < age;
          case 'GREATER_OR_EQUAL':
            return result >= age;
          case 'LESS_OR_EQUAL':
            return result <= age;
        }
      },
      wikiClass: 'ai_utilize_face'
    },
    check_detected_emotion: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getFaceNumber()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getEmotions()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null],
        type: 'check_detected_emotion'
      },
      paramsKeyMap: {
        FACE: 0,
        EMOTION: 1
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        var face = script.getField('FACE', script);
        var emotion = script.getField('EMOTION', script);
        var result = mediaPipeUtils.getFaceEmotion(face);
        return result === emotion;
      },
      wikiClass: 'ai_utilize_face'
    },
    axis_detected_face: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getFaceNumber()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getFacePoint()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getAxis()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null, null],
        type: 'axis_detected_face'
      },
      paramsKeyMap: {
        FACE: 0,
        FACE_POINT: 1,
        AXIS: 2
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        var face = script.getField('FACE', script);
        var point = script.getField('FACE_POINT', script);
        var axisName = script.getField('AXIS', script);
        var axis = mediaPipeUtils.getFacePointAxis(face, point);
        if (axis) {
          return axis[axisName] || 0;
        }
        return 0;
      },
      wikiClass: 'ai_utilize_face'
    },
    get_detected_face_value: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getFaceNumber()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getFaceCategory()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null],
        type: 'get_detected_face_value'
      },
      paramsKeyMap: {
        FACE: 0,
        CATEGORY: 1
      },
      "class": 'face',
      isNotFor: ['faceLandmarker'],
      func: function func(sprite, script) {
        var face = script.getField('FACE', script);
        var category = script.getField('CATEGORY', script);
        if (!mediaPipeUtils.isPrevFaceLandmarker) {
          if (['gender', 'emotion'].includes(category)) {
            return 'null';
          } else {
            return 0;
          }
        }
        switch (category) {
          case 'gender':
            return Lang.video_gender[mediaPipeUtils.getFaceGender(face)] || Lang.Blocks.unknown;
          case 'age':
            return mediaPipeUtils.getFaceAge(face) || 0;
          case 'emotion':
            return Lang.video_emotion_params[mediaPipeUtils.getFaceEmotion(face)] || Lang.Blocks.unknown;
        }
      },
      wikiClass: 'ai_utilize_face'
    }
  };
};